import { graphql } from '@client/graphql/types';
import { useQuery } from '@apollo/client';

const QUERY = graphql(`
  query NailAppointment($id: ID!) {
    nailAppointment(id: $id) {
      ...NailAppointmentItem
    }
  }
`);

export default function useNailAppointment(id: string) {
  return useQuery(QUERY, {
    variables: {
      id,
    },
  });
}
